import { Component, OnInit, Input, ChangeDetectionStrategy, Inject, ChangeDetectorRef } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { LGEDataService } from 'src/commons';

@Component({
    selector: 'confirmation-modal',
    templateUrl: '././confirmation.component.html',
    styleUrls: ['././confirmation.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ConfirmationModalComponent implements OnInit {
    @Input('formName') formName: string;
    @Input('length') length: number;
    @Input('requestName') requestName: string;
    @Input('message') message: string;
    confirmationForm: any;
    isUniqueName = false;
    placeholder: string = '';

    constructor(
        private dialogRef: MatDialogRef<ConfirmationModalComponent>,
        @Inject(MAT_DIALOG_DATA) private data: any,
        private fb: FormBuilder,
        private _dataService: LGEDataService,
        private ref: ChangeDetectorRef,
    ) {
        this.formName = data.title;
        this.length = data.length;
        this.requestName = data.requestName;
        this.message = data.message;
        switch (this.formName) {
            case 'ES':
                this.placeholder = 'Event Name';
                break;
            case 'CG':
                this.placeholder = 'Project Name';
                break;
            default:
                this.placeholder = 'Project Name';
                break;
        }
    }

    ngOnInit() {
        // let formCCName = '';
        // formCCName = this._dataService.getFormCCName();
        this.confirmationForm = this.fb.group({
            formName: [this.requestName, [Validators.required, Validators.maxLength(this.length)]]
        });
    }

    onSubmit() {
        this.dialogRef.close(this.confirmationForm.value);
    }

    onNoClick(): void {
        this.dialogRef.close();
    }

}